export const FILE_MAXIMUM_SIZE = 4096000;
